import type { Props } from './FormError'
import FormError from './FormError'

const FormErrorPerFlag = (props: Props) => {
  return <FormError {...props} />
}

export default FormErrorPerFlag
